import { Body, Box, theme } from '@hover/blueprint';
import { iChevronRight, iX } from '@hover/icons';
import React from 'react';

import { CardHeader } from 'src/modules/designStudio/components/DesignMenu/CardHeader';
import {
  Icon,
  Row,
} from 'src/modules/designStudio/components/DesignMenu/ShareCard/components/common';
import type { Event } from 'src/modules/designStudio/machines/share';
import { FloatingMenu } from 'src/shared/components/FloatingMenu';
import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';
import { Page, buttonPressed } from 'src/shared/telemetry';

interface FloatingShareCardProps {
  headerText: string;
  closeMenu: () => void;
  disabled: boolean;
  send: (event: Event) => void;
}

const COPY_LINK_LABEL = 'Copy Link';

const FloatingShareCard = ({
  headerText,
  closeMenu,
  disabled,
  send,
}: FloatingShareCardProps) => {
  const t = useTranslate(TranslationNamespace.DESIGN_STUDIO);
  const copyLinkTextTranslated = t('share.copyLink');

  const trackButtonPressed = (buttonText: string) =>
    buttonPressed({
      button_text: buttonText,
      item_type: 'copyLinkButton',
      page_or_screen_name: Page.DESIGN_STUDIO,
      primary_cta: false,
    });

  const onPressCopyLink = () => {
    trackButtonPressed(COPY_LINK_LABEL);
    send({ type: 'COPY_LINK' });
  };

  return (
    <FloatingMenu targetElementQuerySelector='[aria-label="share"]'>
      <Box flex={1} flexDir="column">
        <CardHeader
          headerText={headerText}
          marginBottom={0}
          padding={400}
          rightActionHandler={closeMenu}
          rightIcon={iX}
        />

        <Box
          alignItems="center"
          flex={1}
          flexDirection="column"
          justifyContent="space-between"
          width="100%"
        >
          <Box alignItems="center" flex={1} flexDirection="column" width="100%">
            <Box flexDirection="column" width="100%">
              <Row
                aria-label="copy-link"
                borderTop={`1px solid ${theme.colors.neutral[200]}`}
                disabled={disabled}
                fill="minimal"
                height="100%"
                label={copyLinkTextTranslated}
                onClick={onPressCopyLink}
                width="100%"
              >
                <Body size={500}> {copyLinkTextTranslated}</Body>
                <Icon icon={iChevronRight} />
              </Row>
            </Box>
          </Box>
        </Box>
      </Box>
    </FloatingMenu>
  );
};

export { FloatingShareCard, COPY_LINK_LABEL };
